import React, { createContext } from "react";
import useSearchBox from "./useSearchBox.js";
export const SearchBoxContext = createContext(undefined);
const SearchBoxController = (props) => {
    const value = useSearchBox();
    return React.createElement(SearchBoxContext.Provider, { value: value }, props.children);
};
export default SearchBoxController;
